"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unique = void 0;
const unique = (errorMessage) => [
    (data) => { var _a; return new Set(data).size === ((_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0); },
    { message: errorMessage },
];
exports.unique = unique;
//# sourceMappingURL=unique.js.map